
import { defineComponent } from 'vue';

import SeasonAveragesV2 from '@/components/SeasonAveragesV2.vue';
import SeasonStats from '@/components/SeasonStats.vue';
import PlayerDetails from '@/components/PlayerDetails.vue';

export default defineComponent({
  props: {
    playerId: String
  },
  components: {
    SeasonAveragesV2,
    SeasonStats,
    PlayerDetails
  },
  setup() {
    const thisSeason: number = new Date().getFullYear() - 1
    // const lastSeason: number = thisSeason - 1

    return {
      thisSeason,
      // lastSeason
    }
  }
});
